/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

import { ThemeEnum, ThemeType } from './_themes';

/**
 * Theme Context Type Definition
 */

export type ThemeContextType = {
  currentTheme: ThemeType;
  setCurrentTheme: (theme: ThemeType) => void;
};

/**
 * Theme Context Definition
 */

/* istanbul ignore next */
const ThemeContext = createContext<ThemeContextType>({
  currentTheme: ThemeEnum.Blog,
  setCurrentTheme: (theme: ThemeType) => {},
});

export default ThemeContext;
